import { Col, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import Button from '../../../components/Button';

export type PensionVerificationLetterModalProps = {
  showModal: boolean;
  handleClose: () => void;
};

const PensionVerificationLetterSuccessModal = ({
  showModal,
  handleClose,
}: PensionVerificationLetterModalProps) => {
  return (
    <>
      <Modal
        show={showModal}
        onHide={handleClose}
        size={'lg'}
        className={'my-auto'}
      >
        <Modal.Header className={'border-0'} closeButton>
          <Modal.Title className={' ms-auto h6 fw-normal'}>
            Success!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="justify-content-center px-13 mx-3 px-lg-0 mx-lg-0">
            <Col className="d-flex justify-content-center col-10 col-sm-10 col-lg-9">
              <img
                className="img-fluid w-100"
                src={`${process.env.PUBLIC_URL}/${'upload-success.png'}`}
                alt="alarm"
              />
            </Col>
          </Row>
          <Row>
            <Col className="d-flex justify-content-center my-11 pt-5 ">
              <p className="m-0 fw-light text-fs-6  text-center lh-xs ">
                <p className={'w-100 p-0 m-0'}>
                  Pension Verification Letter Requested Successfully!
                </p>
                It takes about 5-7 business days to process and mail the letter.
              </p>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className={'pt-1'}>
          <Button variant={'primary-outline'} onMouseDown={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PensionVerificationLetterSuccessModal;
